import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { UserAlert } from '../../atoms/alerts';
import Bargraph from '../../organisms/BarGraph';
import { HRAImage } from '../../../../assets/images';
import { LodingSquareTabbar } from '../../molecules';
import { DoughnutGraphHRA } from '../../organisms';

const HRA = ({ metricObj, utilizationObj, totalCustomers, sqaureTabHandler, toggleHelp, loading }) => {
  const { donutData, hraCompleted } = metricObj;
  const { barlabels, bardata, barBgColors, xAxesLabel } = utilizationObj;
  const roleflag = ['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'));
  return (
    <div>
      <div className='flex flex-row justify-between mt-8'>
        <div className='flex flex-col w-1/2 mr-4'>
          <p className='text-gray-700 text-base font-semibold mb-3 leading-none'>Percentage of HRA completed</p>
          <DoughnutGraphHRA
            loading={loading}
            loaderHeight={200}
            graphData={donutData}
            hraCompleted={hraCompleted}
            circleTitle='HRA completed'
            title='Number of employees who completed HRA'         
            totalCustomers={metricObj.totalCustomers}
            classes='h-full'
          />
        </div>
        <div className='flex flex-col w-2/4'>
          <p className='text-gray-700 text-base font-semibold mb-3 leading-none'>How to improve the utilization</p>
          {!loading ? (
            <div className='bg-white h-full border p-6 rounded'>
              <img src={HRAImage} alt='india_map' className='mb-4' />

              <p className={`mb-3 text-sm text-gray-500 ${!roleflag && 'mt-8'}`}>
                {roleflag
                  ? 'To improve the utilization of HRA please reach out to the marketing team for a customized plan and share it with your HR'
                  : 'To improve the utilization of HRA please reach out to your customer success manager'}
              </p>
              {!roleflag && (
                <button
                  onClick={() => toggleHelp('Health_Risk_Assessment')}
                  className='block border border-gray-200 text-base font-semibold text-blue-500 focus:outline-none sm:px-5 py-3 leading-none'
                >
                  Connect with CSM
                </button>
              )}
            </div>
          ) : (
            <Skeleton width='100%' height={200} />
          )}
        </div>
      </div>
      <div className='text-base font-semibold mt-9 mb-3 leading-none text-gray-700'>HRA utilization based on</div>
      <LodingSquareTabbar
        list={['Departments', 'Location', 'Age', 'Gender']}
        loaderHeight={30}
        handler={sqaureTabHandler}
        loading={loading}
      />
      <div
        className={'mt-3 rounded-md ' + (loading ? '' : 'bg-white ') + (bardata && bardata.length === 0 ? 'pt-6 ' : '')}
      >
        {bardata && bardata.length === 0 && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes=' p-4 ml-6 mr-4'
          />
        )}
        <Bargraph
          id='utilizationbargraph'
          loading={loading}
          loaderHeight={300}
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel={xAxesLabel}
          yAxesLabel='Utilization percentage'
        />
      </div>
    </div>
  );
};

export default HRA;
